import { preloadImages } from './utils.js';
import { ImageTrail } from './imageTrail.js';

// Detect desktop: must support hover (non-touch) and have a fine pointer (mouse)
const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

if (isDesktop) {
    // Preload all images
    preloadImages('.content__img-inner').then(() => {
        document.body.classList.remove('loading');
        new ImageTrail(document.querySelector('.hero-marquee-section'));
    });
} else {
    // Still remove the loading class so the page isn't stuck
    document.body.classList.remove('loading');
}